//this file is only for using the storage functionality

import firebase from "firebase/compat/app";
import "firebase/compat/storage";
import "firebase/compat/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDMNvCm6XKnA-o4CYazCMdWW101oR2hvhY",
  authDomain: "todoapp-c1580.firebaseapp.com",
  projectId: "todoapp-c1580",
  storageBucket: "todoapp-c1580.appspot.com",
  messagingSenderId: "786340561072",
  appId: "1:786340561072:web:e65d17eec45a7423ee7b75",
  measurementId: "G-B0GLDVXG10",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

const projectStorage = firebase.storage();
const projectFirestore = firebase.firestore();
const timestamp = firebase.firestore.FieldValue.serverTimestamp;

export { projectStorage, projectFirestore, timestamp };
